import { injectStyle } from "./../../utils/style";
import Item from './Item';
injectStyle("components/Form/style/index.css", "[data-duim-0-106-4~=\"dui-m-form-item-text\"]{font-size:12px;height:30px;line-height:30px;font-weight:450}[data-duim-0-106-4~=\"dui-m-form-item-text-error\"]{color:#ff7272}");
var Form = { Item: Item };
export default Form;
export { Form };
